<template>
  <main>
    <div
      class="w-full min-h-screen flex bg-grey"
      :dir="locale == 'ar' ? 'rtl' : 'ltr'"
      :class="locale == 'ar' ? 'font-[Cairo]' : 'font-poppins'"
    >
      <sideBar :items="sideBarItems" />

      <section
        class="flex-grow w-full h-screen flex flex-col max-w-[2000px] mx-auto overflow-y-auto overflow-x-hidden layout-scroll"
      >
        <appHeader @open-drawer="drawerOpen = true" />

        <div class="flex-grow flex flex-col px-2 py-4 lg:px-6 lg:pb-6">
          <div
            class="bg-white flex-grow rounded-[var(--radius-lg)] border border-[var(--border-soft)] shadow-[var(--shadow-soft)] p-5 px-3 lg:p-8 lg:px-10 w-full"
          >
            <transition
              mode="out-in"
              enter-active-class="transition-all duration-300 ease-out"
              enter-from-class="opacity-0 translate-y-3"
              enter-to-class="opacity-100 translate-y-0"
              leave-active-class="transition-all duration-200 ease-in"
              leave-from-class="opacity-100 translate-y-0"
              leave-to-class="opacity-0 -translate-y-2"
            >
              <div :key="route.path">
                <slot></slot>
              </div>
            </transition>
          </div>

          <footer
            class="mt-4 px-2 py-3 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-textColor"
          >
            <p>
              © {{ currentYear }} Tasis —
              {{ $t("tassis_school_system") }}
            </p>
            <p class="opacity-80">{{ $t("manage") }}</p>
          </footer>
        </div>
      </section>

      <deleteModal />
    </div>

    <transition
      enter-active-class="transition-opacity duration-300 ease-out"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="transition-opacity duration-200 ease-in"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <drawer
        v-if="drawerOpen"
        @close="drawerOpen = false"
        :sections="sections"
        :items="sideBarItems"
      />
    </transition>
  </main>
</template>

<script setup>
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import { computed, defineAsyncComponent, ref } from "vue";
import { Repo } from "@/store/admin/repo";
import "flag-icons/css/flag-icons.min.css";

const drawer = defineAsyncComponent(() =>
  import(/* webpackChunkName: "Drawer" */ "@/components/shared/drawer.vue")
);
const sideBar = defineAsyncComponent(() =>
  import(/* webpackChunkName: "Side Bar" */ "@/components/shared/sideBar.vue")
);
const appHeader = defineAsyncComponent(() =>
  import(/* webpackChunkName: "App Header" */ "@/components/shared/appHeader.vue")
);
const deleteModal = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "Delete Modal" */ "@/components/shared/deleteModal.vue"
  )
);

const route = useRoute();
const { locale } = useI18n();

const drawerOpen = ref(false);
const currentYear = new Date().getFullYear();

const sideBarItems = computed(() => {
  return Repo?.user?.type === "TEACHER"
    ? Repo?.sideBarTeacherItems
    : Repo?.sideBarItems;
});

const sections = [];
</script>
